import axios from 'axios'

// URL base dell'API per i referendum, recuperato dall'env file

const REFERENDUM_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'referendum'

const headers = { 'Content-Type': 'application/json' }

class ReferendaService {
    /**
     * Recupera tutti i referendum disponibili nel sistema.
     * Effettua una richiesta GET a `/referendum/all`.
     *
     * @returns {Promise} - Una promessa che restituisce la lista di tutti i referendum.
     */
    getAll() {
        return axios.get(REFERENDUM_REST_API_URL + "/all");
    }

    /**
     * Recupera tutti i referendum associati a un determinato comune.
     * Effettua una richiesta GET a `/referendum/comune/{comId}`.
     *
     * @param {number} comId - L'ID del comune per cui recuperare i referendum.
     * @returns {Promise} - Una promessa che restituisce la lista dei referendum del comune specificato.
     */
    findByComune(comId) {
        return axios.get(REFERENDUM_REST_API_URL + `/comune/${comId}`)
    }

    /**
     * Salva o aggiorna un referendum nel sistema.
     * Effettua una richiesta POST a `/referendum/save` con i dati del referendum.
     *
     * @param {Object} referendum - Oggetto contenente i dettagli del referendum da salvare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server dopo il salvataggio.
     */
    saveReferendum(referendum) {
        return axios.post(REFERENDUM_REST_API_URL + "/save", referendum, headers);
    }

    /**
     * Recupera un referenudm specifico in base al suo ID.
     * Effettua una richiesta GET a `/referendum/{refId}`.
     *
     * @param {number} refId - L'ID del referendum da recuperare.
     * @returns {Promise} - Una promessa che restituisce i dettagli del referendum.
     */
    getReferendum(refId) {
        return axios.get(REFERENDUM_REST_API_URL + `/${refId}`)
    }
}

// Creazione dell'istanza per essere importata direttamente nei componenti
const referendaServiceInstance = new ReferendaService()
export default referendaServiceInstance;